<template>
  <div class="account-page">
    <div class="games">
      <div class="title">
        <h1>Hello {{firstName}}.</h1>
        <p>Subscribe to a project in order to receive an invitation automatically when the beta goes live.</p>
      </div>

      <div v-if="games">
        <div class="game" v-for="game in games">
          <img src="http://via.placeholder.com/150x75" v-bind:src="game.thumbSrc">
          <h2>{{game.name}}</h2>
          <button class="shard-button" v-if="game.subscribed" @click="unsubscribe(game.name)">Unsubscribe</button>
          <button class="shard-button" v-if="!game.subscribed" @click="subscribe(game.name)">Subscribe</button>
        </div>
      </div>

      <div class="" v-if="!games">
        <p>No projects available yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'account-page',
  components: {
  },
  data () {
    return {
      user: {
        displayName: 'Anonymous'
      },
      games: {
        0: {
          subscribed: false
        }
      }
    }
  },
  computed: {
    firstName () {
      return this.user.displayName.substr(0, this.user.displayName.indexOf(' '))
    }
  },
  methods: {
    subscribe (gameName) {
      firebase.database().ref('users/' + this.user.uid + '/games/' + gameName).set({
        subscribed: true
      })

      this.games[gameName].subscribed = true
    },
    unsubscribe (gameName) {
      firebase.database().ref('users/' + this.user.uid + '/games/' + gameName).set({
        subscribed: false
      })

      this.games[gameName].subscribed = false
    },
    updateSubscribeStatus () {
      const uid = firebase.auth().currentUser.uid
      const self = this

      firebase.database().ref('users/' + uid + '/games/').once('value').then(function (snapshot) {
        const subscribeStatus = snapshot.val()
        const gamesLength = Object.keys(self.games).length
        for (let i = 0; i < gamesLength; i++) {
          if (subscribeStatus === null || Object.keys(subscribeStatus)[i] === undefined) {
            firebase.database().ref('users/' + uid + '/games/' + self.games[Object.keys(self.games)[i]].name).set({
              subscribed: false
            })
          } else {
            self.games[Object.keys(self.games)[i]].subscribed = subscribeStatus[Object.keys(subscribeStatus)[i]].subscribed
          }
        }
      })
    }
  },
  beforeCreate () {
    const user = firebase.auth().currentUser

    if (user === null) {
      this.$router.push('/signin')
    } else {
      this.user = user
    }
  },
  mounted () {
    this.user = firebase.auth().currentUser

    const self = this

    firebase.database().ref('/games/').orderByKey().once('value').then(function (snapshot) {
      self.games = snapshot.val()
      self.updateSubscribeStatus()
    })
  }
}
</script>

<style lang="scss" scoped>
.account-page {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  color: white;
  text-align: left;
  overflow: auto;
  font-family: 'Roboto', Arial, sans-serif;
  padding: 60px 20px 0 20px;
}

.title {
  text-align: center;

  h1 {
    text-transform: uppercase;
    font-weight: 900;
    margin-bottom: 20px;
    font-size: 32px;
    letter-spacing: 10px;
  }
}

.games {
  max-width: 960px;
  margin: 40px auto;
}

.game {
  padding: 60px 0 0 0;

  &:last-child {
    border-bottom: none;
  }

  img, h2, button {
    display: inline-block;
    vertical-align: middle;
  }

  img {
    margin-right: 20px;
    border-radius: 2px;
  }

  h2 {
    font-size: 1em;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  .shard-button {
    float: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/account-page.vue